import {axios} from "react-netjoy";

const ResponseFailureInterceptor: axios.AxiosInterceptorResponseErrorInputFunctionType<{}> = (error, serviceClient) => {
    console.log('ResponseFailureInterceptor')
    console.log(JSON.stringify(error))
    throw error
}

export default ResponseFailureInterceptor;
